import React from 'react';
import { reduxForm, change, Field } from 'redux-form';
import { Link } from 'react-router-dom';

import { SelectInput, SelectAsyncInput } from '../SelectInput';
import { TicketsService, UsersService } from '../../services';
import {TextInput} from '../TextInput';

const validate = values => {
  const errors = {}

  if (!values.status) {
    errors.status = 'Please select Status'
  }

  if (!values.type) {
    errors.type = 'Please select Type'
  }

  if (!values.assignedTo) {
    errors.assignedTo = 'Please select Assigned User'
  }

  if (!values.description) {
    errors.description = 'Please enter Description'
  }
  return errors
}

class TicketTaskForm extends React.Component {

  constructor(props) {
    super(props);

    const taskTypeOptions = this.props.taskTypes.map(taskType => ({ value: taskType.id, label: taskType.name, taskType: taskType }));
    const statusOptions = this.props.taskStatuses.map(status => ({ value: status.id, label: status.name, status: status }));

    this.state = {
      statusOptions: statusOptions,
      taskTypeOptions: taskTypeOptions,
      showAssignTo: false
    };
  }

  componentDidMount() {
    if (this.props.task) {
      this.props.initialize({
        description: this.props.task.description,
        type: { value: this.props.task.type.id, label: this.props.task.type.name },
        status: { value: this.props.task.status.id, label: this.props.task.status.name },
        assignedTo: this.props.task.assignedTo ? { value: this.props.task.assignedTo.id, label: this.props.task.assignedTo.fullName } : null
      });
      this.setState({ showAssignTo: this.props.task.status.requiresAssignment });
    } else {
      this.props.initialize({
        type: this.state.taskTypeOptions[0],
        status: this.state.statusOptions[0]
      });
    }
  }

  loadUserOptions(input, callback) {
    if (input.length > 3) {
      UsersService.getAll([{ search: input }], true)
          .then(response => {
            callback(
               response.users.map(user => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`
              }))
            );
          })
          .catch(error => {
            console.error(error);
            callback(error, null);
          });
    } else {
      callback(null, []);
    }
  }
  
  updateStatusValue(newValue) {
    if (!newValue.status.requiresAssignment) {
      this.props.dispatch(change('TicketTaskForm', 'assignedTo', null));
    }
    this.setState({ showAssignTo: newValue.status.requiresAssignment });
  }

  render() {
    return (
      <div>
        <form onSubmit={this.props.handleSubmit}>
          <div className="form-group">
            <label>Status</label>
            <Field
                ref="status"
                options={this.state.statusOptions}
                name="status"
                isClearable={false}
                isSearchable={false}
                component={SelectInput}
                onChange={this.updateStatusValue.bind(this)}
            />
          </div>

          <div className="form-group">
            <label>Type</label>
            <Field
                ref="type"
                options={this.state.taskTypeOptions}
                name="type"
                isClearable={false}
                isSearchable={false}
                component={SelectInput}
            />
          </div>

          {this.state.showAssignTo ? (
            <div className="form-group">
              <label>Assigned User</label>
              <Field
                  ref="assignedTo"
                  loadOptions={this.loadUserOptions.bind(this)}
                  name="assignedTo"
                  isClearable={true}
                  isSearchable={true}
                  component={SelectAsyncInput}
              />
            </div>
          ) : null}

          <div>
            <Field
              type="text"
              name="description"
              component={TextInput}
              label="Description"
              textarea={true}
            />
          </div>

        </form>
      </div>
    );
  }
}

export default reduxForm({ form: 'TicketTaskForm', validate })(TicketTaskForm);
